import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { apiSlice } from './services/apiSlice';
import { livechatApiSlice } from './services/livechatApiSlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import authSlice from './slices/authSlice';
import storage from 'redux-persist/lib/storage';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import userSlice from './slices/userSlice';
import globalSlice from './slices/globalSlice';
import generalSlice from './slices/generalSlice';
import { notificationsSlice } from './slices/notificationSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  [livechatApiSlice.reducerPath]: livechatApiSlice.reducer,
  auth: authSlice,
  global: globalSlice,
  user: userSlice,
  general: generalSlice,
  notifications: notificationsSlice.reducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat(apiSlice.middleware, livechatApiSlice.middleware),
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
